import Subheading from './Subheading';

export { Props } from './Subheading';
export default Subheading;
